// extracted by mini-css-extract-plugin
export var hidden = "_4h-1";
export var leftPanel = "_4h-2";
export var readonlyInspector = "_4h-3";
export var rightPanel = "_4h-0";